import { Card, CardContent, CardHeader } from "@mui/material";
import { SERIES_COLORS } from "./chartTheme";
import ShareBars from "./ShareBars";

const formatCount = (value) => Number(value).toLocaleString("en-US");

// Card with a ranked list of counts (e.g. components per type). One series,
// so every bar has the same color; the labels carry identity.
const CountCard = ({ title, data, totalLabel, emptyText = "Nothing reported yet", sx }) => {
  const items = (data || [])
    .filter((item) => Number(item.value) > 0)
    .map(({ id, label, value }) => ({ id, label, value }));
  return (
    <Card elevation={0} sx={{ ...sx }}>
      <CardHeader title={title} sx={{ pb: 0 }} />
      <CardContent>
        <ShareBars
          data={items}
          title={totalLabel}
          valueFormat={formatCount}
          fullValueFormat={formatCount}
          color={SERIES_COLORS[0]}
          emptyText={emptyText}
        />
      </CardContent>
    </Card>
  );
};

export default CountCard;
